import React, { Component } from 'react'

import { withStyles } from '@material-ui/core/styles'
import { FormControl, InputLabel, Input, InputAdornment, IconButton, Grid } from '@material-ui/core'

import '../../styles/auth-pages.css'

import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = theme => ({
    root: {
        color: 'inherit',
        fontFamily: 'Montserrat',
        display: 'flex'
    },
    cssLabel: {
        font: 'inherit',
        color: 'inherit',
        '&$cssFocused': {
            color: 'white',
        },
    },
    cssFocused: {},
    cssUnderline: {
        borderBottom: 'white !important',
        '&:after': {
          borderBottom: `1px solid white`,
      },
      '&:focused::after': {
          borderBottom: `1px solid white`,
      },
      '&:error::after': {
          borderBottom: `1px solid white`,
      },
      '&:before': {
          borderBottom: `1px solid white`,
      },
      '&$disabled:before': {
          borderBottom: `1px solid white`,
      },
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: `1px solid gray !important`,
      },
    },
    input: {
        fontWeight: 200
    }
});

class Veterinary extends Component {
    constructor(props){
        super(props);

        this.state = {
            name: '',
            email: '',
            phone: '',
            document: '',
            estate: '',
            password: '',

            showPassword: false
        }
    }

    handleChange = (event) => {
        this.props.userInput(event);
    };

    handleClickShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }))
    }

    render(){
        const { classes } = this.props;
        return (
            <div className='input-form'>
                <FormControl fullWidth>
                    <InputLabel htmlFor="text-input"
                        classes={{
                            root: classes.cssLabel,
                            focused: classes.cssFocused,
                        }}
                        className='input-label'
                    >
                        Nome
                    </InputLabel>
                        <Input
                            classes={{
                                root: classes.root,
                                focused: classes.cssFocused,
                                underline: classes.cssUnderline,
                            }}
                            className='input-field'
                            id="name-input"
                            type="email" required
                            name="name"
                            onChange={this.handleChange}
                        />
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel htmlFor="email-input"
                        classes={{
                            root: classes.cssLabel,
                            focused: classes.cssFocused,
                        }}
                        className='input-label'
                    >
                        E-mail
                    </InputLabel>
                        <Input
                            classes={{
                                root: classes.root,
                                focused: classes.cssFocused,
                                underline: classes.cssUnderline,
                            }}
                            className='input-field'
                            id="email-input"
                            type="email" required
                            name="email"
                            onChange={this.handleChange}
                        />
                </FormControl>
                <FormControl fullWidth>
                    <InputLabel htmlFor="text-input"
                        classes={{
                            root: classes.cssLabel,
                            focused: classes.cssFocused,
                        }}
                        className='input-label'
                    >
                        Telefone
                    </InputLabel>
                        <Input
                            classes={{
                                root: classes.root,
                                focused: classes.cssFocused,
                                underline: classes.cssUnderline,
                            }}
                            className='input-field'
                            id="phone-input"
                            type="text" required
                            name="phone"
                            onChange={this.handleChange}
                        />
                </FormControl>
                <Grid container direction='row'>
                    <Grid item md={8}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="text-input"
                                classes={{
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused,
                                }}
                                className='input-label'
                            >
                                CRMV
                            </InputLabel>
                                <Input
                                    classes={{
                                        root: classes.root,
                                        focused: classes.cssFocused,
                                        underline: classes.cssUnderline,
                                    }}
                                    className='input-field'
                                    id="document-input"
                                    type="text" required
                                    name="document"
                                    onChange={this.handleChange}
                                />
                        </FormControl>
                    </Grid>
                    <Grid item md={2}/>
                    <Grid item md={2}>
                        <FormControl fullWidth>
                            <InputLabel htmlFor="text-input"
                                classes={{
                                    root: classes.cssLabel,
                                    focused: classes.cssFocused,
                                }}
                                className='input-label'
                            >
                                UF
                            </InputLabel>
                                <Input
                                    classes={{
                                        root: classes.root,
                                        focused: classes.cssFocused,
                                        underline: classes.cssUnderline,
                                    }}
                                    className='input-field'
                                    id="estate-input"
                                    type="text" required
                                    name="estate"
                                    onChange={this.handleChange}
                                />
                        </FormControl>
                    </Grid>           
                </Grid>
                <FormControl fullWidth>
                    <InputLabel htmlFor="password-input"
                        classes={{
                            root: classes.cssLabel,
                            focused: classes.cssFocused,
                        }}
                        className='input-label'
                    >
                        Senha
                    </InputLabel>
                    <Input
                        classes={{
                            root: classes.root,
                            focused: classes.cssFocused,
                            underline: classes.cssUnderline,
                        }}
                        className='input-field'
                        id="password-input"
                        type={this.state.showPassword ? "text" : "password"} required
                        name="password"
                        onChange={this.handleChange}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="Muda a visibilidade da senha"
                                    onClick={this.handleClickShowPassword}
                                >
                                {this.state.showPassword ? <Visibility style={{color:'white'}}/> : <VisibilityOff style={{color:'white'}}/>}
                                </IconButton>
                            </InputAdornment>
                }/>
                </FormControl>

            </div>
        )
    }        
} 

export default withStyles(styles)(Veterinary);